/** 행사 유형 (UrlValidation EventType과 동일) */
export const EVENT_TYPE = {
  OPENING_WAREHOUSE: 1,
  FESTA: 2,
  PAJUSPIEL: 3,
} as const;

export type EventTypeCode = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];

export interface AdminEventCreatePayload {
  /** 로컬 자정 기준 ISO 문자열 등 */
  startDate: string;
  endDate: string;
  type: EventTypeCode;
  urlCode: string;
  name: string;
}

/** `GET /admin/events?name=` 응답 항목 (최소 필드) */
export interface AdminEventListItem {
  id: number;
  name: string;
  startAt?: string | number;
  endAt?: string | number;
}
